<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>ECOSYSTEM</div>
				<h2 waHeading="l" waText>Plugin &amp; Component Catalog</h2>
				<p waBody="m" waColorText="quiet" waText>Production-ready modules for every use case.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_8"></markdown>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="brand">19 Plugins</wa-tag>
					<wa-tag pill variant="neutral">9 Categories</wa-tag>
					<wa-tag pill variant="success">JPMS Modular</wa-tag>
				</div>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Rendering &amp; UI</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>JWebMP Core</h3>
						<p waBody="s" waColorText="quiet" waText>Strongly-typed HTML/CSS/JS component model</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>JWebMP 2.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Guice 7</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/core']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>JWebMP Client</h3>
						<p waBody="s" waColorText="quiet" waText>Client SPI contracts</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>JWebMP 2.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Guice 7</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/client']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>WebAwesome</h3>
						<p waBody="s" waColorText="quiet" waText>Modern, accessible web component library</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>WebAwesome 1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/web-awesome']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>WebAwesome Pro</h3>
						<p waBody="s" waColorText="quiet" waText>Premium WebAwesome plugin</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>WebAwesome 1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/web-awesome-pro']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Angular Generation</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Angular Plugin</h3>
						<p waBody="s" waColorText="quiet" waText>Generates complete Angular 21 TypeScript projects from Java annotations</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Angular 20</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">STOMP/WebSocket</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/angular']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Angular Maven Plugin</h3>
						<p waBody="s" waColorText="quiet" waText>Maven build plugin that drives the full Angular build lifecycle</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Maven / Angular CLI 3.9.6+ / 20</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Maven Plugin</wa-tag>
							<wa-tag pill variant="neutral">Angular CLI</wa-tag>
							<wa-tag pill variant="neutral">Docker</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/angular-maven-plugin']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>TypeScript Client Annotations</h3>
						<p waBody="s" waColorText="quiet" waText>Annotation library for describing Angular metadata in Java</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Angular / TypeScript 20 / 5</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/typescript-client']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Data &amp; Grids</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Grid</h3>
						<p waBody="s" waColorText="quiet" waText>Feature-rich data grid &#40;AG Grid 35.0.0&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Grid 35.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Grid 35.0.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/aggrid']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Grid Enterprise</h3>
						<p waBody="s" waColorText="quiet" waText>Enterprise grid features</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Grid Enterprise 35.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Grid Enterprise 35.0.0</wa-tag>
							<wa-tag pill variant="neutral">AG Charts 13.0.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/aggrid-enterprise']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Charts &amp; Visualisation</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Charts</h3>
						<p waBody="s" waColorText="quiet" waText>Enterprise charting &#40;AG Charts 13.1.0&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Charts 13.1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Charts 13.1.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/agcharts']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Charts Enterprise</h3>
						<p waBody="s" waColorText="quiet" waText>Advanced chart types</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Charts Enterprise 13.1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Charts Enterprise 13.1.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/agcharts-enterprise']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Chart.js</h3>
						<p waBody="s" waColorText="quiet" waText>Lightweight charting with Chart.js</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Chart.js 2.x</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Chart.js</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/chartjs']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Scheduling</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>FullCalendar</h3>
						<p waBody="s" waColorText="quiet" waText>Full-featured calendar &#40;FullCalendar 6.1.19&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>FullCalendar 6.1.19</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">FullCalendar 6.1.19</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fullcalendar']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>FullCalendar Pro</h3>
						<p waBody="s" waColorText="quiet" waText>Premium calendar features</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>FullCalendar Pro 6.1.19</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">FullCalendar Pro 6.1.19</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fullcalendar-pro']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Icons</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Font Awesome</h3>
						<p waBody="s" waColorText="quiet" waText>Font Awesome Free 7.2.0</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Font Awesome 7.2.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Font Awesome 7.2.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fontawesome']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Font Awesome Pro</h3>
						<p waBody="s" waColorText="quiet" waText>Font Awesome Pro 7.2.0</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Font Awesome Pro 7.2.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Font Awesome Pro 7.2.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fontawesome-pro']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Animation</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Easing Effects</h3>
						<p waBody="s" waColorText="quiet" waText>33 easing timing functions from easings.net</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Easing / easings.net 1.4.1</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Easing 1.4.1</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/easing']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Real-Time Messaging</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>RabbitMQ Comms</h3>
						<p waBody="s" waColorText="quiet" waText>Bidirectional browser-to-server messaging via RabbitMQ</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>RabbitMQ / STOMP.js / SockJS 3.x</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">RabbitMQ 3.x</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">STOMP</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/rabbitmq']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Runtime &amp; Server</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>JWebMP Vert.x</h3>
						<p waBody="s" waColorText="quiet" waText>Vert.x 5 HTTP connector</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Eclipse Vert.x 5</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">Guice 7</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/vertx']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>